import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useTrackEvent } from "../../segment/segment";
import { EventTypeEnum } from "../../segment/types";
import { roomAtom } from "../../video-sdk";
import { isInSessionWithSelectedClientAtom } from "../state";

export const useSendClientInfoTabViewTrackingEvent = (
  patientShortId: string,
  event: EventTypeEnum,
) => {
  const isInSession = !!useAtomValue(roomAtom);
  const isInSessionWithSelectedClient = useAtomValue(
    isInSessionWithSelectedClientAtom,
  );

  const { userViewed } = useTrackEvent();

  useEffect(
    function trackUserViewsByInSessionStatus() {
      userViewed(event, {
        inSession: isInSession,
        patientShortId,
        isViewingUpcomingClient: !isInSessionWithSelectedClient,
      });
    },
    // We only want to send a tracking event on initial view, and not resend it if the inSession or patientShortId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [event],
  );
};
